
import CustomButton from '../../../stateless/customButton/CustomButton';
import { NavLink } from 'react-router-dom';

import { useTaskPreviewController } from './TaskPreviewPaneController';
import Menu from '../../menu/Menu';
import { Loader } from '@progress/kendo-react-indicators';
import FileTab from './FileTab';

interface ITaskPreviewPaneProps {
  title: string;
  priorityLabel: string;
  onClosePreviewPane: (event: any) => void;
  priority: any;
  filing: any;
}

const TaskPreviewPane = (props: ITaskPreviewPaneProps) => {
  const { 
    title: propTitle,
    priorityLabel,
    onClosePreviewPane,
    priority,
    filing, 
  } = props;
  const {
    // functions
    selectTab,
    parseUTCDate,
    // redux
    chapter,
    // state
    menuItems,
    tabSelected,
  } = useTaskPreviewController(filing)

  const renderTitleDisplay = () => {
    if (filing.titleNumber && filing.titleName) {
      return (<div><b>Title:</b> {filing.titleNumber}, {filing.titleName}</div>);
    }
    if (filing.titleNumber) {
      return (<div><b>Title:</b> {filing.titleNumber}</div>);
    }
    if (filing.titleName) {
      return (<div><b>Title:</b> {filing.titleName}</div>);
    }
    return (<div><b>Title:</b></div>);
  }

  const renderChapterDisplay = () => {
    return (<div><b>Chapters:</b> <ul>{filing.associatedChapters.map((chapter: any) => (
      <li>
        {chapter.chapterName && chapter.chapterNumber ? (
          <li>{chapter.chapterNumber}: {chapter.chapterName}</li>
        ) : chapter.chapterName ? (
          <li>{chapter.chapterName}</li>
        ) : (
          <li>{chapter.chapterNumber}</li>
        )}
      </li>
    ))}</ul></div>)
  }

  return (
    <div className="k-taskboard-pane k-taskboard-preview-pane">
      <div className="k-taskboard-pane-header">
        <div className="k-taskboard-pane-header-text">{propTitle}</div>
        <span className="k-spacer" />
        <div className="k-taskboard-pane-header-actions">
          <CustomButton
            icon="close"
            fillMode="flat"
            themeColor='dark'
            onClick={onClosePreviewPane}
          />
        </div>
      </div>

      <Menu menuItems={menuItems} objectKey="label" onClick={selectTab} />
      {tabSelected === 'Filing Details' ? (
        <>
          <div className="k-taskboard-pane-content">
            <p>
              <b>{priorityLabel}</b>
              &nbsp;
              <span style={{ backgroundColor: priority.color }}>&nbsp;</span>
              &nbsp;
              {priority.priority.replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase()}
            </p>
            <p>{renderTitleDisplay()}</p>
            {renderChapterDisplay()}
            <p><b>Docket:</b> {filing.docketNumberDto?.docketNumber}</p>
            <p><b>Hearing Date:</b> {filing.hearingDate ? parseUTCDate(filing.hearingDate) : "No hearing date"}</p>
            <p><b>Agency Name:</b> {filing.agencyName ?? "No agency name found"}</p>
            <p><b>Agency Note:</b> {filing.filingDetail?.agencyNotes ?? "No agency notes found"}</p>
            <p><b>Agency Phone:</b> {filing.filingDetail?.agencyPhone ?? "No agency phone number found"}</p>
          </div>
          <div className="k-taskboard-pane-actions k-actions k-hstack k-justify-content-end">
            <NavLink className="nav-link" to={`/state/filings/${filing.id}`}>
              <CustomButton onClick={() => { }}>Open Filing</CustomButton>
            </NavLink>
          </div>
        </>
      ) : (
        <div className="k-taskboard-pane-content">
          <FileTab
            filingId={filing.id}
          />
        </div>
      )
      }
    </div >
  )
}

export default TaskPreviewPane